<template>
  <div class="form__group field">
    <div class="form-check">
      <label for="cc-me" class="form-check-label">
        <input type="checkbox" class="form-check-input" id="cc-me" name="cc-me" v-model="localCcme">
        Eine Kopie der Anfrage an meine E-Mail-Adresse senden
      </label>
    </div>
  </div>
</template>

<script>
export default {
  props: ["ccme"],
  data() {
    return {
      localCcme: this.ccme
    };
  },
  watch: {
    localCcme() {
      this.$emit("update:ccme", this.localCcme);
    }
  }
};
</script>
